export const RoundedClasses = {
    ROUNDED_NONE: ['wf-rounded-none'],
    ROUNDED_SM: ['wf-rounded-sm'],
    ROUNDED_MD: ['wf-rounded'],
    ROUNDED_LG: ['wf-rounded-lg'],
    ROUNDED_FULL: ['wf-rounded-full']
}